import {EdcUiThemeConfig} from './edc-ui-theme-config';

export const SOVITY_THEME: EdcUiThemeConfig = {
  theme: 'theme-sovity',
  brandFaviconSrc: '/assets/images/sovity_favicon-192x192.png',
  brandLogoSrc: '/assets/images/sovity_logo.svg',
  brandLogoStyle: 'width: 70%;',
};

export const MDS_THEME: EdcUiThemeConfig = {
  theme: 'theme-mds',
  brandFaviconSrc: '/assets/images/mds_favicon.ico',
  brandLogoSrc: '/assets/images/mds_logo.svg',
  brandLogoStyle: 'height: 57px; margin-top: 5px; margin-left: 5px;',
};
export const UBI_SINNOGENES_THEME: EdcUiThemeConfig = {
  theme: 'theme-ubi-sinnogenes',
  brandFaviconSrc: '/assets/images/sinnogenes_favicon.png',
  brandLogoSrc: '/assets/images/sinnogenes-logo.png',
  brandLogoStyle: 'width: 100%; padding-left: 2px; padding-bottom: 2px;',
};
export const UBI_ENFLATE_THEME: EdcUiThemeConfig = {
  theme: 'theme-ubi-enflate',
  brandFaviconSrc: '/assets/images/enflate_favicon.png',
  brandLogoSrc: '/assets/images/enflate-logo-transparent.png',
  brandLogoStyle: 'width: 100%; padding-left: 2px; padding-bottom: 2px;',
};
